import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { darken } from 'polished';
import colors from '~/styles/colors';

export const Container = styled.div`
  background: ${colors.carbon};
  padding: 0px 1rem;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  nav {
    flex: 1;
    border: 0;
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  a {
    display: flex;
    align-items: center;
    img {
      height: auto;
      width: 20rem;
      margin-right: 20px;
      padding-right: 20px;
    }
  }
  aside {
    display: flex;
    align-items: center;

    button {
      padding: 12px 30px;
      background: #d44059;
      border-radius: 4px;
      border: 0;
      font-size: 16px;
      font-weight: bold;
      color: white;
    }
  }
`;

export const Profile = styled.div`
  display: flex;
  margin-right: 30px;
  div {
    text-align: right;
    strong {
      display: block;
      color: #ffff;
    }
    a {
      display: block;
      margin-top: 4px;
      font-size: 14px;
      color: #999;
    }
  }
`;
export const NavLinkItem = styled(NavLink).attrs({
  activeStyle: {
    backgroundColor: darken(0.1, colors.carbon),
  },
})`
  display: flex;
  align-items: center;
  background-color: ${colors.carbon};
  color: #fff;
  font-weight: bold;
  font-size: 1.5rem;
  text-transform: uppercase;
  padding: 2rem;
  transition: 1s background-color;
  &:hover {
    background-color: ${darken(0.1, colors.carbon)};
  }
  svg {
    margin-right: 0.8rem;
    height: 2rem;
    width: 2rem;
  }
`;
